
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '@react-hook/media-query';

const Home = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isSmallScreen = useMediaQuery('only screen and (max-width: 670px)');

  
  const images = [
    { img: "/image/14.png" },
    { img: "/image/12.png" },
    { img: "/image/15.png" },
    { img: "/image/19.png" }
  ];
  const visibleImages = isSmallScreen ? images.slice(0, 4) : images.slice(0, 3);

  return (
    <div className=' w-[100%] bg-background flex flex-col h-min[100vh]'>
      <div className='bg-background sm:px-6 md:px-6 lg:px-16'>
        <div className="h-[200px] md:h-auto flex w-auto p-2">
          <img
            className=" w-[100%] flex justify-center h-auto lg:h-[46vh] items-center pointer-events-none"
            src="/image/Header_Img.png"
            alt="Digital Texting Printing"
          />
        </div>
        <div className='flex flex-col sm:flex-row px-4 flex-grow'>
          <div className='sm:w-[30%] lg:w-[40%] '>
            <div className='m-2 lg:pr-6'>
              <p style={{ fontSize: "14px" }} className='mt-8  text-justify font-poppins'>
                Digital textile printing is a modern method of printing designs, patterns, or images directly onto fabric using digital technology. It involves the use of specialized inkjet printers that are specifically designed for printing on textiles. The process starts with creating or selecting a digital design or pattern using computer software.
              </p>
              
              <div className={`${isSmallScreen ? ` flex justify-center mb-3` : ""}`}>
              <Link to="/designs" >
              <button className='bg-button flex justify-center  text-white font-bold px-10 py-2 mt-4 lg:mt-6 rounded-3xl'>
                SHOP NOW
              </button>
              </Link>

              </div>
            </div>
          </div>
  
          <div className={` px-2 flex  flex-wrap lg:justify-center  flex-row w-[100%] sm:w-[70%] lg:w-[60%]`}>
            {visibleImages?.map((i, index) => (
              <img
                src={i.img}
                srcSet={i.img}
                className='w-[50%] px-2 h-auto lg:py-5 lg:w-[33%] py-2 lg:mt-0 lg:h-[34vh]   sm:h-auto pointer-events-none'
                key={index}
                alt={`Image ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
